const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  isZh: state => state.app.language === 'zh',
  size: state => state.app.size,
  device: state => state.app.device,
  isProd: state => state.settings.isProd,
  env: state => state.settings.env,
  version: state => state.settings.version,
  visitedViews: state => state.tagsView.visitedViews,
  visitedViewsStack: state => state.tagsView.visitedViewsStack,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  currentTenantMenus: state => state.user.menuInfo.menus,
  currentTenantStatMenus: state => state.user.menuInfo.explore,
  currentTenantStatViewReportIds: state => state.user.menuInfo.viewReportIds,
  currentOfficeId: state => state.user.currentOffice.officeId,
  currentOfficeLevel: state => state.user.currentOffice.level,
  currentUserConfig: state => state.user.config,
  currentOfficeUuid: state => state.user.currentOffice.uuid,
  currentOffice: state => state.user.currentOffice,
  currentDeptId: state => state.user.currentDept.departmentId,
  currentDeptUuid: state => state.user.currentDept.uuid,
  currentDept: state => state.user.currentDept,
  userInfo: state => state.user.userInfo,
  userId: state => state.user.userInfo.userId,
  tenantId: state => state.user.userInfo.tenantId,
  isGroupCompany: state => !!state.user.userInfo.groupCompany, // 是否为集团公司
  isAdmin: state => state.user.userInfo && (state.user.userInfo.userType === 2 || state.user.userInfo.userType === 1), // 是否admin 【系统管理员是userType=2，平台客服是userTyp=1】
  isPlatform: state => state.user.userInfo && (state.user.userInfo.userType === 1 || state.user.userInfo.userId === (state.user.userInfo.tenantId + 250000000)), // 是否平台客服 【平台客服是userTyp=1】
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  logs: state => state.log.logs,
  showedOweRemind: state => state.app.showedOweRemind,
  isLowerThenScreen1366: state => state.app.isLowerThenScreen1366,
  isP1: state => state.user.userInfo.tenantId === 1,
  enableFrontEndPlugin: state => state.frontEndPlugin.enable === 1,
  frontEndPluginUrl: state => state.frontEndPlugin.url
}
export default getters
